'use strict';

module.exports = /[^\d.-]/;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/object/var/NON_DECIMAL_REG.js
// module id = 840
// module chunks = 1